
/**
 * Get property value of a nested object defined by a path.
 * E.g: if `source` is {level1: {level2: 'value'}}, `name` is 'level1.level2', then it returns 'value';
 * @param {object} source Object to search in.
 * @param {string} name Path to look up in `source`. Dots selects the levels of the `source` object.
 */
 export const subGet = function(source, name) {
    if (!source || typeof name !== 'string') {
        return undefined;
    }
    let nameParts = name.split('.');
    if (nameParts.length > 1) {
        let currLevelName = nameParts.shift();
        let currLevelNameParts = currLevelName.split('|');
        if (currLevelNameParts.length > 1) {
            currLevelName = currLevelNameParts.shift();
        }
        if (typeof source[currLevelName] === 'undefined' || source === null) {
            return undefined;
        }
        if (typeof source[currLevelName] === 'function')
            return subGet(source[currLevelName](...currLevelNameParts), nameParts.join('.'));
        return subGet(source[currLevelName], nameParts.join('.'));
    }

    nameParts = name.split('|');
    if (nameParts.length > 1) {
        name = nameParts.shift();
    }
    
    if (typeof source[name] === 'function') {
        return source[name](...nameParts);
    }

    return source[name];
}

/**
 * Sets property in a nested object defined by a path.
 * @param {object} source Object to search in.
 * @param {string} name Path to look up in `source`. Dots selects the levels of the `source` object.
 * @param {*} value Value to set.
 */
 export const subSet = function(source, name, value) {
    let nameParts = name.split('.');
    if (nameParts.length > 1) {
        let currLevelName = nameParts.shift();
        if (Array.isArray(source[currLevelName]) && source[currLevelName].length == 0) {
            //delete source[currLevelName];
        }

        if (typeof source[currLevelName] === 'undefined' || source[currLevelName] === null) {
            if (isNaN(nameParts[0])) {
                source[currLevelName] = {};
            } else {
                source[currLevelName] = [];
            }
        }
        return subSet(source[currLevelName], nameParts.join('.'), value);
    }
    if (source) {
        source[name] = value;
    } else {
        console.log('Tying to set member of invalid value:', source, name, value);
    }
}